import { Grid, Stack } from "@mui/material";
import { FileDownload } from "../../../components/common";
import { formatDate } from "../../../helpers/formatDate";
import useGetStatements from "../../../hooks/useGetStatements/useGetStatements";

const ProfileStatements = () => {
  const { data: statements } = useGetStatements();

  return <Stack direction="column" spacing={2} width="100%" alignItems="flex-start">
    <h1>Statements</h1>
    <Stack direction={{ xs: "column", lg: "row" }} spacing={2} width="100%">
      <Grid container spacing={2} height="fit-content">
        {statements.map((statement) => (
          <Grid item xs={12} md={6} xl={4} key={statement.name}>
            <FileDownload fileName={statement.originalFileName} fileUrl={`${process.env.REACT_APP_API_URL.replace(/\/$/, '')}${statement.file}`} fileDescription={statement.createdAt ? formatDate(new Date(statement.createdAt), 'short') : '-'} required={true} />
          </Grid>
        ))}
      </Grid>
    </Stack>
  </Stack>;
};

export default ProfileStatements;